/************************************
MODULE: Trustpilot Percentage
WHAT IT DOES: it restrict colors icons proportionaly to the rating so it helps to show semi-colored icons
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function initTrustpilotPercentages() {

        var trustpilotPercentages = $('.js-trustpilot-percentage');
        if (!trustpilotPercentages.length)
            return;

        for (var i = 0, l = trustpilotPercentages.length; i < l; i++) {
            initTrustpilotPercentage(trustpilotPercentages.eq(i));
        }
        
     }

    function initTrustpilotPercentage(trustpilotPercentage) {
        var percentage = parseInt(trustpilotPercentage.find('[data-trustpilot-rating-percentage]').data('trustpilot-rating-percentage'));
        var trustpilotPercentageFilledIcons = trustpilotPercentage.find('.js-trustpilot-percentage-filled-icons');
        trustpilotPercentageFilledIcons.width(percentage + '%');
    }

    return {
        init: initTrustpilotPercentages
    }

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.trustpilotpercentage.js
 ** module id = 66
 ** module chunks = 24
 **/